<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">Eksport</div>

                <!-- <v-select :items="types" label="Type eskport" filled></v-select> -->

                <application-search-by-date-year class="body-1" @updated="datesUpdated"></application-search-by-date-year>

                <br>

                <div class="d-flex align-center">

                    <div class="mx-1"></div>

                    <!-- <v-btn @click="showApplications = !showApplications" :disabled="applications.length == 0" text width="225px">
                        <v-icon left>{{showApplications? 'mdi-eye-off': 'mdi-eye'}}</v-icon>
                        {{showApplications? "skjul":"vis"}} {{applications.length}} søknader
                    </v-btn> -->

                    <!-- <div class="mx-1"></div> -->

                    <v-btn :disabled="selectedApplications.length == 0" color="success" @click="exportExcel">
                        <v-icon left>mdi-export-variant</v-icon>
                        {{this.selectedApplications.length}} eksport til excel
                    </v-btn>

                    <div class="mx-1"></div>

                    <v-btn :disabled="selectedApplications.length == 0 " :color="downloadingPdf == this.downloadStatus.NOTDOWNLOADING ? 'success':'error'" @click="exportPdf">
                        <div style="display: grid;">
                            <div class="d-flex align-center" :style="{visibility: downloadingPdf == this.downloadStatus.NOTDOWNLOADING? 'visible':'hidden', 'grid-column': 1, 'grid-row': 1}">
                                <v-icon left>mdi-file-pdf-box-outline</v-icon>
                                {{this.selectedApplications.length}} eksport til pdf
                            </div>

                            <div :style="{visibility: downloadingPdf == this.downloadStatus.DOWNLOADING? 'visible':'hidden', 'grid-column': 1, 'grid-row': 1}">
                                <div class="d-flex align-center justify-center">
                                    STOPP
                                    <!-- <v-progress-linear v-model="pdfProgress" class="ma-2"></v-progress-linear> -->
                                    <v-progress-circular size="28" width="2" :value="Math.floor(pdfProgress)" class="ma-2">
                                        <div class="caption">
                                            {{Math.floor(pdfProgress)}}
                                        </div>

                                    </v-progress-circular>
                                    <!-- {{Math.floor(pdfProgress)}}% -->
                                </div>
                            </div>

                            <div :style="{visibility: downloadingPdf == this.downloadStatus.STOPPING? 'visible':'hidden', 'grid-column': 1, 'grid-row': 1}">
                                <div class="d-flex align-center justify-center">
                                    STOPPER...
                                    <v-progress-circular size="28" width="2" indeterminate class="ma-2">
                                    </v-progress-circular>
                                </div>
                            </div>
                        </div>

                        <!-- <template v-slot:loader>
                            <div class="d-flex align-center">
                                STOPP
                                <v-progress-circular size="28" width="2" :value="Math.floor(pdfProgress)" class="ma-2">
                                    <div class="caption">
                                        {{Math.floor(pdfProgress)}}
                                    </div>

                                </v-progress-circular>
                            </div>
                        </template> -->
                    </v-btn>
                </div>

                <br>

                <v-expand-transition hide-on-leave>
                    <v-card>
                        <v-card-title>
                            Søknader
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="søk" single-line hide-details clearable></v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :search="search" v-if="showApplications" :items="applications" :headers="headers" show-select v-model="selectedApplications" hide-default-footer disable-pagination :mobile-breakpoint="-1">

                                <template v-slot:item.ownedBy="{item}">
                                    {{item}}
                                </template>
                                <template v-slot:item.name="{item}">
                                    {{item.name}}
                                </template>
                                <template v-slot:item.Status="{item}">
                                    {{item}}
                                </template>
                                <template v-slot:item.createdAt="{item}">
                                    {{moment.unix(item.createdAt).format("YYYY-MM-DD HH:mm")}}
                                </template>

                                <!-- <template v-slot:body="{ items}">
                            <tbody>
                                <tr v-for="item in items" :key="item.id" :class="{'error lighten-4': getRawStatus(item).type === applicationStatus().CREATED || getRawStatus(item).type === applicationStatus().STALE || getRawStatus(item).type === applicationStatus().UNKNOWN}">
                                    <td>
                                        <v-checkbox v-model="item.isSelected"></v-checkbox>
                                    </td>
                                    <td>
                                        <div>
                                            {{item.ownedBy.name}}
                                        </div>
                                    </td>
                                    <td>{{item.name}}</td>
                                    <td>{{getStatus(item)}}</td>
                                    <td>{{moment.unix(item.createdAt).format("YYYY-MM-DD HH:mm")}}</td>
                                </tr>
                            </tbody>
                        </template> -->
                            </v-data-table>
                        </v-card-text>
                    </v-card>

                </v-expand-transition>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as moment from "moment";
import * as axios from "axios";

const downloadStatus = {
    NOTDOWNLOADING: 0,
    DOWNLOADING: 1,
    STOPPING: 2
}

export default {
    data() {
        return {
            // types: ["Oversikt"],

            from: undefined,
            to: undefined,

            showApplications: true,
            search: undefined,
            applications: [],
            selectedApplications: [],
            headers: [
                { text: "Organisasjon", value: "ownedBy.name" },
                { text: "Søknad", value: "name" },
                { text: "Status", value: "status" },
                { text: "Opprettet på", value: "createdAt" }
            ],

            files: undefined,
            moment: moment,
            downloadStatus: downloadStatus,
            downloadingPdf: downloadStatus.NOTDOWNLOADING,
            pdfProgress: 0,
        };
    },
    methods: {
        async datesUpdated(from, to){
            this.getApplications(from, to);
        },
        async getApplications(from, to) {
            this.from = moment(from).startOf("day").unix();
            this.to = moment(to).endOf("day").unix();
            // debugger;

            let response = await axios.get(`/application/between?from=${this.from}&to=${this.to}&include=[ownedBy,statuses]`);

            this.applications = response.data.map(app => {
                app.status = this.getStatus(app);
                return app;
            });
        },
        getRawStatus(application){
            if(!application?.statuses.length){
                return undefined;
            }
            let status = application.statuses[application.statuses.length -1];
            // let isCreatedStatus = status.type === this.applicationStatus().CREATED;
            // console.log(`${application.name} -> ${isCreatedStatus}`);
            return status;
        },
        getStatus(application){
            if(!application?.statuses.length){
                return "-";
            }
            return this.applicationStatusText(application.statuses[application.statuses.length -1].type);
        },
        async exportExcel() {
            let response = await axios.get(`/exporting?from=${this.from}&to=${this.to}`, {
                // headers: {
                //     "content-type": "application/octet-stream"
                // }
            });
            // debugger;
            let filedata = response.data;
            let blob = new Blob([Buffer.from(filedata, "base64")], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;" });

            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "demo.xlsx";

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
        },
        async exportPdf() {
            if(this.downloadingPdf == downloadStatus.STOPPING){
                return;
            }
            if(this.downloadingPdf == downloadStatus.DOWNLOADING){
                this.downloadingPdf = downloadStatus.STOPPING;
                return;
            }

            // this.downloadingPdf == downloadStatus.NOTDOWNLOADING
            this.downloadingPdf = downloadStatus.DOWNLOADING;

            let failedExports = [];
            let downloadedExports = [];            

            for (let index = 0; index < this.selectedApplications.length; index++) {
                if(this.downloadingPdf == downloadStatus.STOPPING){
                    break;
                }

                const app = this.selectedApplications[index];
                try {
                    let filedata = (await axios.post(`/exportPdf/generate`, { applicationId: app.id})).data;
                    let blob = new Blob([Buffer.from(filedata,"base64")], {type:"application/pdf"});
                    var link = document.createElement("a");

                    link.href = window.URL.createObjectURL(blob);
                    link.download = `${app.name}_${moment().format("YYYYMMDDHHmm")}.pdf`;

                    document.body.appendChild(link);

                    link.click();

                    document.body.removeChild(link);
                } catch (error) {
                    failedExports.push(app.name);
                }

                this.pdfProgress = ((index+1)/this.selectedApplications.length)*100;
                downloadedExports.push(app.name);
            }


            if(failedExports.length > 0){
                this.$store.commit("snackbar", {
                    text: `${failedExports.length} søknader ikke eksportet til PDF: ${failedExports.join(", ")}.`,
                    color: "error",
                    show: true
                });
            }
                
            if(failedExports.length == 0){
                this.$store.commit("snackbar", {
                    text: `${downloadedExports.length} søknader eksportet til PDF.}`,
                    color: "success",
                    show: true
                });
            }

            this.pdfProgress = 0;
            this.downloadingPdf = downloadStatus.NOTDOWNLOADING;
        },
        s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
            return buf;
        }
    },
    mounted() {
        moment.locale("nb");
    }
};
</script>

<style lang="scss">
</style>